<template>
  <div>
    <v-autocomplete
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      clearable
      hide-details
      item-text="title"
      item-value="id"
      label="Search..."
      solo
      class="ml-3 blue"
      prepend-inner-icon="mdi-magnify"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            Search for <strong>composer</strong>, <strong>project</strong> or
            <strong>news</strong>
          </v-list-item-title>
        </v-list-item>
      </template>
      <!-- <template v-slot:selection="{ attr, on, item, selected }">
				<v-chip
				 	v-bind="attr"
				 	:input-value="selected"
				 	color="blue-grey"
				 	class="white--text"
				 	v-on="on">
				 	<v-icon left>
						mdi-bitcoin
				 	</v-icon>
				 	<span v-text="item.name"></span>
				</v-chip>
			</template> -->
      <template v-slot:item="{ item }">
        <v-row
          v-if="isNextCategory(item)"
          style="position: absolute; top: 0px;"
        >
          <v-subheader
            :key="item.category"
            v-text="_.capitalize(item.category)"
          ></v-subheader>
        </v-row>

        <v-row
          v-if="item.category == 'projects'"
          @click="
            $router.push(
              '/discography/' + item.first_artist_id + '/project/' + item.id
            )
          "
          class="mx-3"
          :class="isNextCategory(item) ? 'mt-10' : ''"
        >
          <v-list-item-avatar
            color="accent"
            class="headline font-weight-light white--text project"
          >
            <v-img v-if="item.photo" :src="item.photo"></v-img>
            <v-img
              src="@/assets/LOGO_ALBUM.jpg"
              contain
              class="default-image"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              v-text="$options.filters.truncate(item.title, 50, ' ')"
            ></v-list-item-title>
            <v-list-item-subtitle v-text="item.year"></v-list-item-subtitle>
          </v-list-item-content>
          <!-- <v-list-item-action>
					 	<v-icon>mdi-library-music-outline</v-icon>
					</v-list-item-action> -->
        </v-row>

        <v-row
          v-if="item.category == 'artists'"
          @click="$router.push('/discography/' + item.id)"
          class="mx-3"
          :class="isNextCategory(item) ? 'mt-10' : ''"
        >
          <v-list-item-avatar
            color="accent"
            class="headline font-weight-light white--text"
          >
            <v-img v-if="item.photo" :src="item.photo"></v-img>
            <v-img
              src="@/assets/LOGO_ALBUM.jpg"
              contain
              class="default-image"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
            <v-list-item-subtitle v-text="item.job"></v-list-item-subtitle>
          </v-list-item-content>
          <!-- <v-list-item-action>
					 	<v-icon>mdi-artist-outline</v-icon>
					</v-list-item-action> -->
        </v-row>

        <v-row
          v-if="item.category == 'news'"
          @click="$router.push('/news/' + item.id)"
          class="mx-3"
          :class="isNextCategory(item) ? 'mt-10' : ''"
        >
          <v-list-item-avatar
            color="accent"
            class="headline font-weight-light white--text"
          >
            <v-img v-if="item.photo" :src="item.photo"></v-img>
            <v-img
              src="@/assets/LOGO_NEWS_50.png"
              contain
              class="default-image"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content two-line>
            <v-list-item-title
              v-text="$options.filters.truncate(item.title, 50, ' ')"
            ></v-list-item-title>
            <v-list-item-subtitle
              v-text="
                $options.filters.truncate(
                  stripHtmlTags(item.description),
                  50,
                  ' '
                )
              "
            ></v-list-item-subtitle>
          </v-list-item-content>
          <!-- <v-list-item-action>
					 	<v-icon>mdi-newspaper</v-icon>
					</v-list-item-action> -->
        </v-row>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  name: "TheSearch",
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    search: null,
    tab: null,
    categories: []
  }),

  watch: {
    search(val) {
      this.model = null;
      if (val == undefined || val.length == 0) {
        this.items = [];
        this.categories = [];
        return;
      }
      // Items have already been loaded
      // if (this.items.length > 0) return

      this.isLoading = true;

      // Lazily load input items
      fetch(this.$BASE_URL + "/search/" + val)
        .then(res => res.clone().json())
        .then(res => {
          this.categories = [];
          this.items = res;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  computed: {},
  methods: {
    stripHtmlTags(text) {
      if (text == null) return "";
      return text.replace(/(<([^>]+)>)/gi, "");
    },
    isNextCategory(item) {
      let before = this.items[this._.indexOf(this.items, item) - 1];

      if (this._.indexOf(this.items, item) == 0) return true;

      if (before == null) debugger; // eslint-disable-line
      if (before.category != item.category) return true;

      return false;
    }
  }
};
</script>
<style lang="sass">
.default-image
  position: absolute !important
  z-index: 0 !important

.v-avatar .v-image
  position: relative
  z-index: 1

.v-menu__content.theme--dark.v-menu__content--fixed.menuable__content__active.v-autocomplete__content
  right: 0px !important
  left: unset !important
  max-width: 100%
  max-height: 80% !important

  @media (min-width: 768px)
    max-width: 520px



.v-avatar.v-list-item__avatar.headline.font-weight-light.white--text.project
  border-radius: 5px !important

.v-input__slot
  background-color: rgb(45 45 45)
  margin-left: -1px

.v-input__control
  margin-right: -1px
</style>
